import { SnackbarProvider } from 'notistack'

import SnackbarNotificationCloseButton from '../components/snackbar-notification-close-btn'

const SnackbarNotificationProvider = ({ children }: { children: React.ReactNode[] | React.ReactNode }) => (
  <SnackbarProvider
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    maxSnack={3}
    hideIconVariant={true}
    action={(key) => <SnackbarNotificationCloseButton buttonKey={key} />}
  >
    {children}
  </SnackbarProvider>
)

export default SnackbarNotificationProvider
